import { Directive, HostListener, ElementRef, HostBinding } from '@angular/core';
import { AppAbstractDirective } from './appAbstractDirective';

@Directive({
  selector: '[appLowerCase]'
})
export class AppLowerCaseDirective extends AppAbstractDirective {

  constructor(private element: ElementRef) {
    super();
  }

  @HostBinding('class')
  elementClass = 'lowerCase';

  @HostListener('focus') onFocus(): void {
    this.element.nativeElement.select();
  }

}
